import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, computed, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useGeneral } from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const isAdjustPosition = ref<boolean>(false);
const generalStore = useGeneral();
const { floatText } = storeToRefs(generalStore);
const positionLeft = computed(() => floatText.value.left);
const isVisible = computed(() => floatText.value.show);

const textRef = ref<HTMLElement | null>(null);
watch(
  () => positionLeft.value,
  (newVal) => {
    if (newVal) {
      isAdjustPosition.value =
        !!textRef.value &&
        textRef.value.clientWidth + newVal > document.body.clientWidth;
    }
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'float-text',
      {
        'float-text--show': _unref(isVisible),
        'float-text--adjust': isAdjustPosition.value,
      },
    ]),
    style: _normalizeStyle({ top: `${_unref(floatText).top}px`, left: `${_unref(positionLeft)}px` }),
    ref_key: "textRef",
    ref: textRef
  }, _toDisplayString(_unref(floatText).text), 7))
}
}

})